import React from "react";
import Navigation from "./navigation/Navigation";

const Header = () => {
  return (
    <header className="header">
      <Navigation />
    </header>
  );
};

export default Header;
